const config = {
  namespace: 'App',
  API_URL: process.env.REACT_APP_API_URL,
  GOOGLE_MAP_API_KEY: process.env.REACT_APP_GOOGLE_MAP_API_KEY as string,
  GOOGLE_AUTH_API_KEY: process.env.REACT_APP_GOOGLE_AUTH_API_KEY as string,
  URL_IMAGES: 'https://cinemahive.s3.amazonaws.com/images/',
  TOKEN: process.env.REACT_APP_TOKEN as string,
  REFRESH_TOKEN: process.env.REACT_APP_REFRESH_TOKEN as string,
  ID_MY_PROJECT: process.env.REACT_APP_MY_PROJECT as string,
  USERS_TYPES: ['company', 'person'],
  VERIFY_MESSAGE: 'Please, verify your email',
  PER_PAGE_LIST: 20,
  PREFIX_CALENDAR: 'calendar',
};

export default config;
